/**
 * アプリ全体に効かせる素の CSS。
 *
 * 実行時は `main.tsx` が `<style>` として head に流し込む。
 * **プリレンダーしたトップページ（`dist/_home.html`）でも同じものを head に入れる**
 * ため、ここに切り出して1箇所で持つ。片方だけ直すと、JS が動く前の
 * トップページだけ余白が崩れた状態で見える。
 */
export const globalStyles = `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    /* 認証画面(AuthLayout)と同じ背景をアプリ全体の既定にする。
       ダッシュボードだけ変えると、他の画面へ遷移した瞬間に白へ戻って
       ちぐはぐに見えるため、body に置いて全画面へ effect させる。
       LP・規約・プライバシー・特商法は各自で背景色を指定しているので影響しない。
       fixed にしているのは、コンテンツが長い画面でグラデーションが
       繰り返されたり途中で途切れたりするのを防ぐため。 */
    min-height: 100vh;
    background: linear-gradient(160deg, #F1F5F9 0%, #E2E8F0 55%, #DBEAFE 100%) fixed;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  input, select, button {
    font-family: inherit;
  }

  button {
    cursor: pointer;
  }

  button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
